"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { requestTypes, participantConstants } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";
import { ajaxError, participantActiveParticipantComplete, participantDeleteParticipantComplete, participantGetApplicationComplete, participantGetAreasComplete, participantGetDealersComplete, participantGetParticipantSummaryComplete, participantGetParticipantSummaryRequest, participantGetRolesComplete, participantSaveNewParticipantComplete, participantUpdateDealerComplete, participantUpdateJobRoleComplete, participantUpdateParticipantStatusComplete } from "../_actions";


export const participantGetApplicationEpic = (actions$) => {
    return actions$.pipe(
         ofType(participantConstants.PARTICIPANT_GET_APPLICATION_REQUEST),
         mergeMap((action) => {
              return ajax
                   .post(
                        "/api/participant/getApplication",
                        action.payload,
                        getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                   )
                   .pipe(
                        map((ajaxResponse) => {
                             return participantGetApplicationComplete(
                                  ajaxResponse.response,
                             );
                        }),
                        catchError((error) => of(ajaxError(error))),
                   );
         }),
    );
};

export const participantGetParticipantSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_GET_PARTICIPANT_SUMMARY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/getSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return participantGetParticipantSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantGetAreasEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_GET_AREAS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/getAreas",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return participantGetAreasComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantGetDealersEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_GET_DEALERS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/getDealers",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return participantGetDealersComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantGetRolesEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_GET_JOB_ROLES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/getRoles",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return participantGetRolesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantSaveNewParticipantEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_SAVE_NEW_PARTICIPANT_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/save",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return participantSaveNewParticipantComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantUpdateParticipantStatusEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_UPDATE_PARTICIPANT_STATUS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/update-status",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   participantUpdateParticipantStatusComplete(
                                        ajaxResponse.response,
                                   ),
                                   participantGetParticipantSummaryRequest({
                                        applicationId: action.payload.applicationId,
                                        page: action.payload.page,
                                        pageSize: action.payload.pageSize,
                                      })
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantDeleteParticipantEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_DELETE_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/delete",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   participantDeleteParticipantComplete(
                                        ajaxResponse.response,
                                   ),
                                   participantGetParticipantSummaryRequest({
                                        applicationId: action.payload.applicationId,
                                        page: action.payload.page,
                                        pageSize: action.payload.pageSize,
                                      })
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantActiveParticipantEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/send-active-mail",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   participantActiveParticipantComplete(
                                        ajaxResponse.response,
                                   ),
                                   // participantGetParticipantSummaryRequest({
                                   //      applicationId: action.payload.applicationId,
                                   //      page: action.payload.page,
                                   //      pageSize: action.payload.pageSize,
                                   //    })
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantUpdateDealerEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_SEND_PARTICIPANT_UPDATE_DEALER_SHIP_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/update-dealer",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   participantUpdateDealerComplete(
                                        ajaxResponse.response,
                                   ),
                                   // participantGetParticipantSummaryRequest({
                                   //      applicationId: action.payload.applicationId,
                                   //      page: action.payload.page,
                                   //      pageSize: action.payload.pageSize,
                                   //    })
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };

 export const participantUpdateJobRoleEpic = (actions$) => {
     return actions$.pipe(
          ofType(participantConstants.PARTICIPANT_SEND_PARTICIPANT_UPDATE_PARTICIPANT_JOB_ROLE_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/participant/update-job-role",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   participantUpdateJobRoleComplete(
                                        ajaxResponse.response,
                                   ),
                                   // participantGetParticipantSummaryRequest({
                                   //      applicationId: action.payload.applicationId,
                                   //      page: action.payload.page,
                                   //      pageSize: action.payload.pageSize,
                                   //    })
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
 };